import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as DepositeModels from '../../../../../../src/app/models/deposite/deposite';
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";
import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';

@Component({
    selector: 'app-deposites',
  templateUrl: './deposites.component.html',
  styleUrls: ['./deposites.component.css']
})

export class DepositesComponent extends AldFormBaseComponent implements OnInit {


  public requestGet: Models.RequestModel = null;

  public deposites: DepositeModels.DepositeModel[];

  public requestGarageVisitRequest: Models.Request<DepositeModels.DepositeModel> = new Models.Request<DepositeModels.DepositeModel>();


  @Select(AldState.Deposites)
  Deposites$: Observable<Models.ResponseList<DepositeModels.DepositeModel>>;

  @Select(AldState.GarageVisitRequest)
  GarageVisitRequest$: Observable<Models.Response<GarageVisitsModels.GarageVisitRequestModel>>;

    constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef
    ) {

      super(helperService, environmentService, changeDetectorRef, router, authenticationService, store);
    }

  ngOnInit() {

    super.ngOnInit();

    this.subscription.add(this.Deposites$.subscribe((data) => {
      if (data && data.Success) {
        this.deposites = data.Items;
        }
    }));

    this.subscription.add(this.GarageVisitRequest$.subscribe((data) => {

      if (data && data.RequestSignature == this.requestGarageVisitRequest.RequestSignature && data.Success) {

        this.requestGarageVisitRequest.End();

        this.onHome();
      }
    }));

    }


  public onUserAuthenitcate() {

    if (this.currentUser && this.currentUser.CarId) {

      this.requestGet = new Models.RequestModel(this.currentUser.CarId);

      this.store.dispatch(new AldActions.DepositesGet(this.requestGet));
    }
  }

  onDepositeVisit(Deposite: DepositeModels.DepositeModel) {
    if (this.currentUser) {
      this.router.navigate(['/deposite-visit', Deposite.DepositeId]);
    }
  }

  onDepositeRelocate(Deposite: DepositeModels.DepositeModel) {
    if (this.currentUser) {
      this.router.navigate(['/relocation-order', Deposite.DepositeId]);
    }
  }

  onDepositeVisitRequest(Deposite: DepositeModels.DepositeModel) {
    if (this.currentUser) {

      this.requestGarageVisitRequest.Begin();

      this.requestGarageVisitRequest.Item = Deposite;

      this.store.dispatch(new AldActions.GarageVisitRequestForDeposite(this.requestGarageVisitRequest));
    }
  }

  public onSummary() { }
}
